import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { toSlug, toCategoryKey } from "../utils/slugUtils";
import "../styles/henk.css";
import ProductCard from "../shared/ProductCard";
import { Col, Row } from "reactstrap";
import "../styles/typeproduct.css";
import { useTranslation } from "react-i18next";
import { Select } from "antd";

import bannerHenk from "../assets/images/bannerProductHenk.png";
import bannerHenkMobile from "../assets/images/bannerProductHenkMobile.png";
import bannerHenkTablet from "../assets/images/bannerProductHenkTablet.png";
import bannerMark from "../assets/images/bannerProductMarkandmilk.png";
import bannerMarkMobile from "../assets/images/bannerProductMarkandmilkMobile.png";
import bannerMekong from "../assets/images/bannerProductMekongCocoa.png";
import bannerMekongMobile from "../assets/images/bannerProductMekongCocoaMobile.png";
import bannerGanafarm from "../assets/images/bannerProductGanafarm.png";
import bannerGanafarmMobile from "../assets/images/bannerProductGanafarmMobile.png";
import bannerMarkTablet from "../assets/images/bannerProductMarkandmilkTablet.png";
import bannerMekongTablet from "../assets/images/bannerProductMekongCocoaTablet.png";
import bannerGanafarmTablet from "../assets/images/bannerProductGanafarmTablet.png";
import iconAllFillter from "../assets/images/allFilter-icon.png";

import logoHenk from "../assets/images/logoHenkBlack.png";
import logoMark from "../assets/images/logoMarkandmilkWhite.png";
import logoMekong from "../assets/images/logoMekongcocoaYellow.png";
import logoGanafarm from "../assets/images/logoGanafarmBlack.png";

const { Option } = Select;

const bannerMap = {
  henk: bannerHenk,
  "mark-and-milk": bannerMark,
  "mekong-cocoa": bannerMekong,
  ganafarm: bannerGanafarm,
};
const bannerMapMobile = {
  henk: bannerHenkMobile,
  "mark-and-milk": bannerMarkMobile,
  "mekong-cocoa": bannerMekongMobile,
  ganafarm: bannerGanafarmMobile,
};
const bannerMapTablet = {
  henk: bannerHenkTablet,
  "mark-and-milk": bannerMarkTablet,
  "mekong-cocoa": bannerMekongTablet,
  ganafarm: bannerGanafarmTablet,
};

const bannerContentMap = {
  henk: {
    text: "desc_henk_detail",
    logo: logoHenk,
    classname: "henk-Product",
  },
  "mark-and-milk": {
    text: "desc_markandmilk_detail",
    logo: logoMark,
    classname: "markandmilk-Product",
  },
  "mekong-cocoa": {
    text: "desc_mekongcocoa_detail",
    logo: logoMekong,
    classname: "mekong-Product",
  },
  ganafarm: {
    text: "desc_ganafarm_detail",
    logo: logoGanafarm,
    classname: "ganafarm-Product",
  },
};

const TypeProduct = () => {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [selectedLoai, setSelectedLoai] = useState("tatca");
  const [availableLoaiSP, setAvailableLoaiSP] = useState([]);
  const [loading, setLoading] = useState(true); // Thêm trạng thái loading
  const location = useLocation();
  const { t } = useTranslation();

  let tenloaisp = 0;
  if (id === "henk") {
    tenloaisp = 1;
  } else if (id === "mekong-cocoa") {
    tenloaisp = 7;
  } else if (id === "ganafarm") {
    tenloaisp = 8;
  } else if (id === "mark-and-milk") {
    tenloaisp = 2;
  }

  const [isLaptop, setIsLaptop] = useState(window.innerWidth <= 1399);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 529);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 529);
      setIsTablet(window.innerWidth <= 767);
      setIsLaptop(window.innerWidth <= 1399);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get("page");
    setPage(pageParam ? Number(pageParam) : 0);
    setSelectedLoai("tatca");
  }, [location, id]);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true); // Bắt đầu loading
      try {
        const response = await fetch(
          `https://dht.api.mekongzone.com.vn/api/products/`,
          {
            credentials: "include",
          }
        );
        if (!response.ok) {
          if (response.status === 503) {
            throw new Error(
              "Máy chủ API tạm thời không khả dụng, vui lòng thử lại sau!"
            );
          }
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();

        if (data) {
          const filtered = data.filter(
            (product) => product.maloaisp === tenloaisp
          );

          const types = [...new Set(filtered.map((p) => p.dongSanPham))];
          setAvailableLoaiSP(types);

          const filteredProducts = filtered.filter(
            (product) =>
              selectedLoai === "tatca" || product.dongSanPham === selectedLoai
          );

          const enhancedProducts = filteredProducts
            .map((prod) => {
              const khoiluongWithUnit =
                prod.khoiluong && prod.donViTinh
                  ? `${prod.khoiluong}${prod.donViTinh}`
                  : prod.khoiluong || "Không xác định";
              const slug = toSlug(prod.tensp, prod.masp);

              let weightInGrams = 0;
              if (khoiluongWithUnit) {
                const match = khoiluongWithUnit.match(
                  /(\d+(\.\d+)?)(g|ml|kg)/i
                );
                if (match) {
                  const value = parseFloat(match[1]);
                  const unit = match[3].toLowerCase();
                  weightInGrams =
                    unit === "kg"
                      ? value * 1000
                      : unit === "g" || unit === "ml"
                      ? value
                      : value;
                }
              }

              return {
                ...prod,
                khoiluong: khoiluongWithUnit,
                slug,
                weightInGrams,
                isSoCoLa:
                  tenloaisp === 8 &&
                  prod.tensp.toLowerCase().startsWith("sô cô la"),
              };
            })
            .sort((a, b) => {
              if (tenloaisp === 8) {
                if (a.isSoCoLa && !b.isSoCoLa) return -1;
                if (!a.isSoCoLa && b.isSoCoLa) return 1;
              }
              return a.weightInGrams - b.weightInGrams;
            });

          setProducts(enhancedProducts);
          setPage(0);
          setPageCount(Math.ceil(enhancedProducts.length / 8));
        } else {
          setProducts([]);
          setPageCount(0);
        }
      } catch (err) {
        setProducts([]);
        setPageCount(0);
      } finally {
        setLoading(false); // Kết thúc loading dù thành công hay lỗi
      }
    };

    fetchProducts();
  }, [id, selectedLoai, tenloaisp]);

  const changePage = (pageNumber) => {
    setPage(pageNumber);
    window.history.pushState(null, "", `/san-pham/${id}?page=${pageNumber}`);
  };

  const currentPageProducts = products.length
    ? products.slice(page * 8, (page + 1) * 8)
    : [];

  const handleSelectChange = (value) => {
    setSelectedLoai(value);
  };

  const getTranslationKey = (dongSanPham) => {
    const key = `product_categories.${toCategoryKey(dongSanPham)}`;
    if (t(key) === key) {
      console.warn(
        `Missing translation for key: ${key} (value: ${dongSanPham})`
      );
    }
    return key;
  };

  return (
    <div className="type_products">
      <section className="banner-section">
        {isMobile ? (
          <img
            src={bannerMapMobile[id] || bannerHenkMobile}
            alt=""
            className="banner_product"
          />
        ) : isTablet ? (
          <img
            src={bannerMapTablet[id] || bannerHenkTablet}
            alt=""
            className="banner_product"
          />
        ) : (
          <img
            src={bannerMap[id] || bannerHenk}
            alt=""
            className="banner_product"
          />
        )}
        {bannerContentMap[id] && (
          <div
            className={`banner-content ${bannerContentMap[id].classname} container`}
          >
            <img
              src={bannerContentMap[id].logo}
              alt={`${id} logo`}
              className="banner-logo"
            />
            <p className="banner-text">{t(bannerContentMap[id].text)}</p>
          </div>
        )}
      </section>

      <section>
        <div className="container content-type_products">
          <>
            {isLaptop ? (
              <div className="loaisp__filters">
                <Select
                  value={
                    selectedLoai === "tatca"
                      ? t("product_categories.all_products")
                      : t(getTranslationKey(selectedLoai), selectedLoai)
                  }
                  onChange={handleSelectChange}
                  className="custom-select"
                  placeholder={t("product_categories.all_products")}
                  style={{ width: "100%" }}
                >
                  <Option value="tatca">
                    {t("product_categories.all_products")}
                  </Option>
                  {availableLoaiSP.map((loai) => (
                    <Option key={loai} value={loai}>
                      {t(getTranslationKey(loai), loai)}
                    </Option>
                  ))}
                </Select>
              </div>
            ) : (
              <div className="loaisp__filters d-flex mb-4 justify-content-between flex-wrap align-items-center">
                <div>
                  <button
                    className={`filter__btn ${
                      selectedLoai === "tatca" ? "active" : "all__filter"
                    }`}
                    onClick={() => setSelectedLoai("tatca")}
                  >
                    <div>
                      <img
                        src={iconAllFillter}
                        alt=""
                        className="allfilter__btn"
                      />
                    </div>
                    <p>{t("product_categories.all_products")}</p>
                  </button>
                </div>
                <div className="d-flex gap-2 flex-wrap justify-content-center">
                  {availableLoaiSP.map((loai) => (
                    <button
                      key={loai}
                      className={`filter__btn ${
                        selectedLoai === loai ? "active" : ""
                      }`}
                      onClick={() => setSelectedLoai(loai)}
                    >
                      {t(getTranslationKey(loai), loai)}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </>

          <Row className="products">
            {loading ? (
              <Col lg="12" className="text-center">
                <p>{t("common.loading")}</p> {/* Thêm thông báo "Đang tải..." */}
              </Col>
            ) : currentPageProducts.length > 0 ? (
              currentPageProducts.map((product) => (
                <Col lg="3" key={product.masp} className="product_card">
                  <ProductCard
                    product={product}
                    link={`/san-pham/${id}/${product.slug}`}
                    stateData={{ product }}
                  />
                </Col>
              ))
            ) : (
              <Col lg="12">
                <p className="text-center">
                  {t("product_categories.no_products_found")}
                </p>
              </Col>
            )}
            <Col lg="12">
              <div className="pagination d-flex align-items-center justify-content-center mt-4 gap-3 mb-4">
                {[...Array(pageCount).keys()].map((number) => (
                  <span
                    className={page === number ? "active__page" : ""}
                    key={number}
                    onClick={() => changePage(number)}
                    style={{ cursor: "pointer" }}
                  >
                    {number + 1}
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default TypeProduct;